import { Box, Chip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

type AboutProps = { isSmallScreen: boolean };

function About(_props: AboutProps) {
  const theme = useTheme();

  const skillCategories = [
    {
      title: "Game Engines",
      skills: ["Unity", "Unreal Engine 5", "Godot", "Three.js", "PixiJS"],
    },
    {
      title: "Languages",
      skills: ["C#", "C++", "C", "Lua", "JavaScript", "TypeScript", "Python"],
    },
    {
      title: "Multiplayer & Networking",
      skills: ["Photon", "Mirror", "Netcode for GameObjects", "EOS", "Steamworks", "FishNet"],
    },
    {
      title: "Tools & Practices",
      skills: ["Git", "Agile", "Playtesting & Telemetry", "FSM", "Rapid Prototyping"],
    },
    {
      title: "Game Genres",
      skills: ["Simulation", "Strategy", "Roguelike", "City Builder", "Deckbuilding", "Action", "Racing", "Survival", "Multiplayer Co-op & PvP"],
    },
  ];

  return (
    <Box sx={{ py: 6 }}>
      <Typography variant="h1" fontWeight={700}>
        About <span style={{ color: theme.palette.secondary.main }}>Me</span>
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, maxWidth: 800 }}>
        Gameplay Engineer with over 8 years of experience developing engaging gameplay
        systems across simulation, strategy, action, and multiplayer genres. Skilled in
        architecting core mechanics such as hex-grid building systems, deckbuilding synergies,
        vehicle physics, crew/NPC simulations, and multiplayer networking (up to 16 players).
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, maxWidth: 800 }}>
        MS Computer Science — University of Nebraska–Lincoln
      </Typography>

      {skillCategories.map((category) => (
        <Box key={category.title} sx={{ mb: 3 }}>
          <Typography variant="h3" sx={{ color: theme.palette.secondary.main, py: 0, mb: 1 }}>
            {category.title}
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {category.skills.map((skill) => (
              <Chip
                key={skill}
                label={skill}
                variant="outlined"
                sx={{ borderColor: theme.palette.primary.main }}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default About;
